export default __webpack_public_path__ + "static/media/icon-error.dfaa17e2.svg";